import {useModal} from '@esgi/ui-kit/modal';

export function useAlertRef() {
	return useModal();
}
